import { FunctionComponent } from 'react'
import { Box, IconButton } from '@material-ui/core'
import styled, { keyframes } from 'styled-components/macro'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { UserRoles } from 'common/types'
import { ReactComponent as Slack } from 'icons/slack.svg'
import { ReactComponent as Google } from 'icons/google_icon_color.svg'
import { ReactComponent as LinkedIn } from 'icons/linkedin.svg'
import { GoogleLogin } from 'react-google-login'
import AppleLogin from 'react-apple-login'
import { DEV_ONLY } from 'common/globalConstants'

const pulseBlue = shadow => keyframes`
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 ${shadow};
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(52, 172, 224, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(52, 172, 224, 0);
  }
`

const StyledLinkedIn = styled(LinkedIn)`
  fill: #fff; /*${props => props.theme.colors.accent1};*/
  stroke: #fff; /*${props => props.theme.colors.accent1};*/
  height: 1em;
`
const StyledSlack = styled(Slack)`
  height: 1em;
`
const StyledGoogle = styled(Google)`
  height: 1em;
`
const StyledIconButton = styled(IconButton)`
  && {
    background-color: ${props => props.theme.colors.supplementary};
    margin: 1em 0.5em 0 0;
    height: 2em;
    width: 2em;
    padding: 0.25em;
    border-radius: 30px;
  }
  :hover {
    box-shadow: 0 0 0 0 ${props => props.theme.colors.primary};
    animation: ${pulseBlue(props => props.theme.colors.primary)} 2s infinite;
  }
`

interface SignUpLinkedInProps {
  role: UserRoles
  onLogin: Function
  showEmailSignUp: Function
}

export const SignUpLinkedIn: FunctionComponent<SignUpLinkedInProps> = ({ role }) => {
  const { loginUsingSSO } = useAuth()

  const responseGoogle = (response: any) => {
    loginUsingSSO('google', 'Member', response)
  }
  const googleAppId = process.env.REACT_APP_GOOGLE_APP_ID

  const handleAppleResponse = (response: any) => {
    loginUsingSSO('apple', 'Member', response)
  }

  return (
    <Box display="flex" justifyContent="center" width="100%" mb="2em">
      <GoogleLogin
        clientId={googleAppId}
        render={renderProps => (
          <StyledIconButton
            style={{ backgroundColor: '#fff' }}
            onClick={renderProps.onClick}
            disabled={renderProps.disabled}
          >
            <StyledGoogle />
          </StyledIconButton>
        )}
        buttonText="Login"
        onSuccess={responseGoogle}
        onFailure={responseGoogle}
        cookiePolicy={'single_host_origin'}
      />
      <StyledIconButton style={{ backgroundColor: '#fff' }} onClick={() => loginUsingSSO('slack', role)}>
        <StyledSlack />
      </StyledIconButton>
      <StyledIconButton style={{ backgroundColor: '#0a66c2' }} onClick={() => loginUsingSSO('linkedin', role)}>
        <StyledLinkedIn />
      </StyledIconButton>
      {DEV_ONLY && 
        <AppleLogin
          clientId="com.bptn.appdev"
          redirectURI="https://app-dev.bptn.ca/authenticate"
          usePopup={true}
          callback={handleAppleResponse} // Catch the response
          scope="email name"
          responseMode="query"
          render={(
            renderProps //Custom Apple Sign in Button
          ) => (
            <StyledIconButton
              style={{ backgroundColor: '#717378' }}
              onClick={renderProps.onClick}
              disabled={renderProps.disabled}
            >
              {"A"}
            </StyledIconButton>
          )}
        />
      }
    </Box>
  )
}
/*
<a href="https://slack.com/oauth/v2/authorize?user_scope=identity.basic&client_id=322626754148.2012710575874"><img alt=""Sign in with Slack"" height="40" width="172" src="https://platform.slack-edge.com/img/sign_in_with_slack.png" srcset="https://platform.slack-edge.com/img/sign_in_with_slack.png 1x, https://platform.slack-edge.com/img/sign_in_with_slack@2x.png 2x" />
</a>
*/
